export const environment = {
  production: false,
  WORKFORCE_API: 'https://api-dev-workforce.azurewebsites.net/api/v1/',
  ENABLE_DEBUG: false,
};
